import axiosInstance from '../../core/axiosConfig';
import {
  getAuth,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from 'firebase/auth';

export class MemberService {
  async signIn(firebaseUid: string) {
    const response = await axiosInstance.post('/auth/sign-in', { firebaseUid });
    return response.data;
  }

  async createMember(payload: any) {
    await axiosInstance.post('admin/member/add', payload);
  }

  async createCourier(payload: any) {
    await axiosInstance.post('admin/courier/add', payload);
  }

  async createVendor(payload: any) {
    await axiosInstance.post('admin/vendor/add', payload);
  }

  async deleteMember(id: any) {
    await axiosInstance.delete('admin/member/delete', { params: { id } });
  }

  async updateMember(payload: any) {
    await axiosInstance.patch('admin/member/update', payload);
  }

  async updateVendor(payload: any) {
    await axiosInstance.patch('admin/vendor/update', payload);
  }

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user || !user.email) {
      throw new Error('User not authenticated');
    }

    const credential = EmailAuthProvider.credential(user.email, currentPassword);
    await reauthenticateWithCredential(user, credential);

    await updatePassword(user, newPassword);
  }

  async changeMemberPassword(payload: any): Promise<void> {
    await axiosInstance.patch('admin/member/password/change', payload);
  }
}
